$(document).ready(function() {
	if(!document.querySelector('.GPC0090')) return false;
    function settingDescHeight(){
        $('.GPC0090').each(function () {
            var inner_area =  $(this).find('.merge-inner');
            var box_size1 = inner_area.find('li').eq(0).find('.title-area').outerHeight();
            var box_size2 = inner_area.find('li').eq(1).find('.title-area').outerHeight();
            //console.log(box_size1, box_size2)
            if(box_size1 > box_size2){
                inner_area.find('li').eq(1).find('.title-area').css('height',box_size1);
               
            } else{
                inner_area.find('li').eq(0).find('.title-area').css('height',box_size2);
            }
        });
    }
    /* LGCOMSPEED-6(6th) Start */
    if(document.readyState == 'complete') settingDescHeight();
    /* LGCOMSPEED-6(6th) End */
    $(window).on('load resize', settingDescHeight);
});